<script>
import {nextTick} from 'vue';

export default {
  props: {
    currentProducts: []
  },
  data() {
    return {
      currentStep: 1,
      config: {
        productArea: 'Europe',
        isMember: false
      },
      products: [],
    }
  },

  mounted() {
    this.container = document.querySelector('.js-vue-product-steps');
    this.products = this.currentProducts;
  },

  watch: {
    currentStep(val) {
      this.container.scrollIntoView();
    }
  },

  methods: {
    setProductArea(area) {
      if (!area) {
        return null;
      }

      // Update the area in the config instead of directly selecting a product
      this.config.productArea = area;
      this.currentStep = 2;
    },

    getPriceMonthly() {
      if (!this.selectedProduct || !this.selectedProduct.price || !this.selectedProduct.price.includingDiscount) {
        return '0.00';
      }

      // Calculate monthly price (yearly price divided by 12)
      const yearlyPrice = this.selectedProduct.price.includingDiscount;
      const monthlyPrice = yearlyPrice / 12;

      // Format the price with Swiss number format (thousands separator as ')
      return monthlyPrice.toLocaleString('de-CH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    getPriceYearly() {
      if (!this.selectedProduct || !this.selectedProduct.price || !this.selectedProduct.price.includingDiscount) {
        return '0.00';
      }

      // Get yearly price
      const yearlyPrice = this.selectedProduct.price.includingDiscount;

      // Format the price with Swiss number format (thousands separator as ')
      return yearlyPrice.toLocaleString('de-CH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
  },

  computed: {
    selectedProduct() {
      if (!this.products || this.products.length === 0) {
        return null;
      }

      // Filter products based on config values
      const product = this.products.find(product => {
        // Match area from config
        const areaMatch = product.productArea.toLowerCase() === this.config.productArea.toLowerCase();

        // Match membership status
        const membershipMatch = product.isMember === this.config.isMember;

        // Return product that matches all criteria
        return areaMatch && membershipMatch;
      });

      return product;
    },
  }
}
</script>